<template>
  <div v-if="!item.hidden && item.children" class="menu-wrapper">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow &&
        rolesId.includes(item.meta.role)
      "
    >
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item
            v-if="onlyOneChild.meta"
            :icon="onlyOneChild.meta.icon || item.meta.icon"
            :title="generateTitle(onlyOneChild.meta.title)"
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu
      v-else-if="
        !!(!item.hidden && item.children) && rolesId.includes(item.meta.role)
      "
      ref="subMenu"
      :index="resolvePath(item.path)"
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta.icon"
          :title="generateTitle(item.meta.title)"
        />
        <el-badge
          v-if="item.path === '/codeManage'"
          :value="codeTotal"
          class="item"
        >
        </el-badge>
        <el-badge
          v-if="item.path === '/orderManage'"
          :value="orderTotal"
          class="item"
        >
        </el-badge>
        <el-badge
          v-if="item.path === '/exchange'"
          :value="exchangeTotal"
          class="item"
        >
        </el-badge>
      </template>

      <template v-for="child in item.children">
        <template v-if="!child.hidden && rolesId.includes(child.meta.role)">
          <sidebar-item
            v-if="child.children && child.children.length > 0"
            :is-nest="true"
            :item="child"
            :key="child.path"
            :base-path="resolvePath(child.path)"
            class="nest-menu"
          />

          <app-link v-else :to="resolvePath(child.path)" :key="child.name">
            <el-menu-item :index="resolvePath(child.path)">
              <item
                v-if="child.meta"
                :icon="child.meta.icon"
                :title="generateTitle(child.meta.title)"
              />
            </el-menu-item>
          </app-link>
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { generateTitle } from "@/utils/i18n";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
import { mapGetters } from "vuex";
import { getCodeList } from "@/api/code";
import { getOrderList } from "@/api/order";
import { getExchangeList } from "@/api/exchange";

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  computed: {
    ...mapGetters(["rolesId"]),
  },
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      onlyOneChild: null,
      codeTotal: 0,
      orderTotal: 0,
      exchangeTotal: 0,
      timer: null,
    };
  },
  created() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getData() {
      let codeParams = {
        pageNumber: 1,
        pageSize: 1,
        status: 2,
      };
      getCodeList(codeParams).then((res) => {
        const response = res.data;
        if (response.code === "200") {
          let total = response.data.total;
          this.codeTotal = total;
        }
      });
      let orderParams = {
        pageNumber: 1,
        pageSize: 1,
        status: 0,
      };
      getOrderList(orderParams).then((res) => {
        const response = res.data;
        if (response.code === "200") {
          let total = response.data.total;
          this.orderTotal = total;
        }
      });
      let exchangeParams = {
        pageNumber: 1,
        pageSize: 1,
        status: 0,
      };
      getExchangeList(exchangeParams).then((res) => {
        const response = res.data;
        if (response.code === "200") {
          let total = response.data.total;
          this.exchangeTotal = total;
        }
      });
    },
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      return path.resolve(this.basePath, routePath);
    },

    generateTitle,
  },
};
</script>
